// extracted by mini-css-extract-plugin
module.exports = {"mainPanels":"MainPanels_mainPanels__ica5f","item":"MainPanels_item__zIxR4"};